export enum E2ePingEvents {

    /**
     * Indicates that the end-to-end round-trip-time for a participant has changed.
     */
    E2E_RTT_CHANGED = 'e2eping.e2e_rtt_changed'
}
